export default __webpack_public_path__ + "static/media/podcastCover.fc21f114.jpg";